import {PropertyGridDialogProps, PropertyGridDialog} from "./PropertyGridDialog";
import {getOrCreateDomElement} from "../layer/dialogHelper";
import {renderComponent, unMount} from "../../utils/RenderingUtils";

export { AlertDialog } from './AlertDialog';
export { Dialog } from './Dialog';
export { YesNoDialog } from './YesNoDialog';
export { EitherOrDialog } from './EitherOrDialog';
export { PropertyGridDialog } from "./PropertyGridDialog";

export async function renderPropertyGridDialog(props: PropertyGridDialogProps) {
  const React = await import('react');

  const host = getOrCreateDomElement({ className: '', id: 'dp-property-grid-dialog-host'})

  if (!props.dialogProps)
    props.dialogProps = { open: true };
  const closeAction = props.dialogProps.onClose;
  props.dialogProps.onClose = () => {
    closeAction && closeAction();
    unMount(host, true);
  }

  await renderComponent({
    container: host,
    component: <PropertyGridDialog {...props} />,
    autoUnmount: true
  });
}
